import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=78e717f0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=78e717f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e717f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e717f0')) {
      api.createRecord('78e717f0', component.options)
    } else {
      api.reload('78e717f0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=78e717f0&scoped=true&", function () {
      api.rerender('78e717f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeDZP/detail.vue"
export default component.exports